import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/Kidola.css'; // Adjust the path as necessary
import InventoryListPopupStudent from './InventoryListPopupStudent';
import { MdDelete } from "react-icons/md";
import { BsFiles } from "react-icons/bs";
import { generatePaymentReceiptPDF } from './util/paymentReceipt';


import { useNavigate } from 'react-router-dom';

const StudentLevelupRequestDetailPage = ({ isSidebarCollapsed }) => {
    const { levelupRequestId } = useParams();
    const [student, setStudent] = useState(null);
    const [levelup, setLevelup] = useState(null);   
    const [showInventoryPopup, setShowInventoryPopup] = useState(false);
    const [items, setItems] = useState([]);
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/levelup/detail/${levelupRequestId}`);
                const studentData = response.data.data.studentData || null;
                const studentLevelupRequestData = response.data.data.studentLevelupRequest || null;
                setStudent(studentData);
                setLevelup(studentLevelupRequestData);
            } catch (error) {
                console.error("Failed to fetch student levelup request details", error);
            }
        };

        fetchStudentDetails();
              
    }, [levelupRequestId]);

    const validateForm = () => {
        const errors = {};
    
        // Cek jika field kosong
        if (!paymentDate) errors.payment_date = 'Payment Date is required';
        if (!paymentMethod) errors.payment_method = 'Payment Method is required';

        return errors;
    };
   
    const handleSubmit = () => {
        
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }

            const paymentData = {
                paymentMethod: paymentMethod,
            };
        
            //const paymentDetails = items.map((item) => ({
            //    item: item.item_name,
            //    amount: item.price,
            //}));

            const paymentDetails = [
                {
                  item: `Package Level Up ${levelup?.Level?.level_name || '-'}`,
                  amount: calculateTotalHarga(),
                }
            ];

            const requestBody = {
                data: {
                    inventoryData: 
                        items.map(item => ({
                            inventory_id: item.inventory_id,
                            price: item.price,
                            item_type: item.item_type,
                        }))
                    ,
                    paymentData: {
                      payment_date: paymentDate,  // Set as today’s date
                      payment_amount: calculateTotalHarga(),  // Total payment calculated
                      payment_method: paymentMethod
                    }
                }
            };
            
            api.put(`student/levelup/paymentUpdate/${levelupRequestId}`, requestBody)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                generatePaymentReceiptPDF(student, paymentData, paymentDetails, paymentDate, 'LEVELUP');
                navigate('/success', { state: { message: successMessage } });
                
            })
            .catch(error => {
                console.error('Error adding student:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }

    };

    const formatNumber = (number) => {
        return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
    };

    const calculateTotalHarga = () => {       
        const totalInventory = items.reduce((total, item) => {
          return item.price !== 0 ? total + Number(item.price) : total;
        }, 0);
    
        return totalInventory;
    };

    const handleSelectItems = (selectedItems) => {
        // Ambil item yang belum ada di daftar
        const newItems = selectedItems.filter(selectedItem => 
            !items.some(item => item.inventory_id === selectedItem.inventory_id)
        );
    
        if (newItems.length > 0) {
            setItems((prevItems) => [...prevItems, ...newItems]);
        } 
    };

    const handleDeleteItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
    };

    if (!student) return <p>Loading Level Up Request details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Student Level Up Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Level Up Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Student Name</td>
                                <td>:</td>
                                <td>{student.student_name}</td>
                            </tr>
                            <tr>
                                <td>Teacher Name</td>
                                <td>:</td>
                                <td>{levelup.Teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>Shared Teacher Name</td>
                                <td>:</td>
                                <td>{levelup.shared_teacher ? levelup.shared_teacher.teacher_name : '-'}</td>
                            </tr>
                            <tr>
                                <td>Requested Program</td>
                                <td>:</td>
                                <td>{levelup.Program.program_name}</td>
                            </tr>
                            <tr>
                                <td>Requested Level</td>
                                <td>:</td>
                                <td>{levelup.Level.level_name}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{levelup.Status.status_name}</td>
                            </tr>
                            <tr>
                                <td>Approved On</td>
                                <td>:</td>
                                <td>{moment(levelup.approved_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Payment Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Payment Date</label>
                                </td>
                                <td>:</td>
                                <td>
                                    <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                                </td>
                            </tr>
                            <tr>
                                {errors.payment_date && 
                                <td>
                                    <div className="error-message">{errors.payment_date}</div>
                                </td>
                                }
                            </tr>
                            <tr>
                                <td>
                                    <label>Payment Method</label>
                                </td>
                                <td>:</td>
                                <td>
                                    <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                        <option key="" value="">Choose Payment Method</option>
                                        <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                        <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                {errors.payment_method && 
                                <td>
                                    <div className="error-message">{errors.payment_method}</div>
                                </td>
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Item Data</h3>
                    <div className="package-details">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                    <label>Add Item</label>
                                    </td>
                                    <td>
                                    <BsFiles className="icon" onClick={() => setShowInventoryPopup(true)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {items.length > 0 ?
                    <div className="create-student-table">
                        <table>
                            <thead>
                                <tr>
                                    <th className='table-center-align'>Item Name</th>
                                    <th className='table-center-align'>Price</th>
                                    <th className='no-column'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                    <td>{item.item_name}</td>
                                    <td>{formatNumber(item.price)}</td>
                                    <td>
                                        <MdDelete className="icon" onClick={() => handleDeleteItem(index)} />  
                                    </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td><strong>Total Pembayaran</strong></td>
                                    <td className='table-right-align'><strong>{formatNumber(calculateTotalHarga())}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    :""}
                </div>
                
                
                <div className="search-container">  
                    <button className="approve-reject-button" onClick={() => handleSubmit()}>Submit</button>  
                    <button onClick={() => navigate(`/`)}>Back</button>
                </div>
                {showInventoryPopup && (
                    <InventoryListPopupStudent onSelectItems={handleSelectItems} onClose={() => setShowInventoryPopup(false)} />
                )}
            </div>
        </div>
    );
};

export default StudentLevelupRequestDetailPage;
